import React from 'react';
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";
import {setSQFTSystemMessage} from "../../../../actions/sqftMenuFunctions";

const SqftSystemMessage = (props) => {
  const {systemMessage, setSQFTSystemMessage} = props;

  const handleConfirmClick = () => {
    window.lineInputFocused = false;
    setSQFTSystemMessage({isOpened: false, shape: null});
  };

  return (
    <div className={"full-screen-wrapper " + (systemMessage.isOpened ? "" : "hidden")} id='message-box-wrapper'>
      <div
        className={"message-window-base" + (systemMessage.large ? " message-window-base--large" : "")}
        id='message-box-window'
      >
        <div className="message-system-message-title" id='message-box-title' data-text="sqft.popup.title">
          {systemMessage.title}
        </div>
        <div className='message-blue-lable'>&nbsp;</div>
        <div className="message-system-text-blue" id="message-box-text">
          {systemMessage.content}
        </div>
        <div className="message-system-dismiss-button-wrapper message-system-dismiss-button-setting" onClick={handleConfirmClick}>
          <div className="message-system-dismiss-button" >
            <FormattedMessage id={"sqft.popup.buttonOk"}/>
          </div>
        </div>
      </div>
    </div>
  )
};

const mapStateToProps = (store) => ({
  systemMessage: store.sqftMenuState.systemMessage
});

const mapDispatchToProps = {
  setSQFTSystemMessage
};


export default connect(mapStateToProps, mapDispatchToProps)(SqftSystemMessage);
